import { t } from "i18next";

export enum TABLE_ITEM_LAYOUT_TYPE {
  CHAT_HISTORY = 1,
  FAQ = 2,
  TERMS_CONDITIONS = 3,
  PRIVACY_POLICY = 4,
  SUGGESTED_QUESTION = 5,
  PAYMENT_METHODS = 6,
}

export enum SUBSCRIPTION_TYPE {
  MONTHLY = 1,
  YEARLY = 2,
}

export enum CHAT_LIKE_STATUS {
  NONE = 0,
  LIKED = 1,
  DISLIKED = 2,
}
export enum SUBSCRIPTIONS_TYPE {
  MONTHLY = "Monthly",
  YEARLY = "Yearly",
}

export enum APP_THEME {
  DARK = "dark",
  Light = "light",
  SYSTEM = "system",
}

export enum MENU_TYPE {
  PROFILE = 1,
  LOGOUT = 2,
  THEME = 3,
}
export enum ACTION {
  DELETE = "delete",
  EDIT = "edit",
}

export const REQUIREMENTS = [
  "common:password.length",
  "common:password.combination",
  "common:password.upperCase",
  "common:password.lowerCase",
  "common:password.numbers",
  "common:password.specialCharacters",
];

export const SELECTED_PROFILE_TYPES = {
  PROFILE: "profile",
  PASSWORD: "password",
};

export enum PRIVACY_CONTENT_TYPE {
  TABLE = 1,
}

export const TOAST_VARIANT = {
  ERROR: "error",
  SUCCESS: "success",
  COPY_SUCCESS: "copy_success",
  INFO: "warning",
  WARNING: "warning",
};

export const TOAST_VARIANT_COLORS: allAnyTypes = {
  [TOAST_VARIANT.ERROR]: {
    borderColor: "#F6C23A",
    textColor: "#18191B",
    backgroundColor: "rgba(246, 194, 58, 0.2)",
  },
  [TOAST_VARIANT.SUCCESS]: {
    borderColor: "#40DC91",
    textColor: "#18191B",
    backgroundColor: "#EEFFF7",
  },
  [TOAST_VARIANT.COPY_SUCCESS]: {
    textColor: "#FFFFFF",
    backgroundColor: "#2F3438",
  },
  [TOAST_VARIANT.INFO]: {
    borderColor: "#50B7F0",
    textColor: "#18191B",
    backgroundColor: "#EEF9FF",
  },
  [TOAST_VARIANT.WARNING]: {
    borderColor: "#F6C23A",
    textColor: "#18191B",
    backgroundColor: "#FFFAEC",
  },
};

export const LOADER_STYLES = {
  size: "xl",
  color: "blue",
  thickness: "4px",
};

export const PAGINATION_DEFAULTS = {
  PAGESIZE: 10,
  THREAD_PAGE_SIZE: 10,
  DOCUMENT_LIST: 20,
  MAX: 200,
};

export const enum TABS_VARIANT {
  DEFAULT = "default",
  CTA = "cta",
}
export const RECORDS_PER_PAGE = 10;
export const FILES_PER_PAGE = 5;
export const DOCUMENTS_FILTER = "Recents";

// Layout offsets
export const SYSTEM_CHAT_LAST_ITEM_OFFSET = 220; // Pixels to be subtracted from 100vh

export const enum RESPONSE_STATUS {
  SEARCH = "search",
  FILE = "file",
  WEBPAGE = "webpage",
  YOUTUBE = "youtube",
  DEEP_SEARCH = "deepsearch",
}

export const enum CHATBOT_TYPE {
  LAW_CHATBOT = "1",
  PERMIT_ITEM_EXTRACTION_CHATBOT = "2",
  MULTI_DOCUMENT_CHATBOT = "3",
  PROJECT_DOCUMENT_CHATBOT = "4",
  DRAWING_ANALYSIS_CHATBOT = "5",
  KCS_CHATBOT = "6",
}

export const enum LAW_MODE {
  LAW_CASE = "search",
  LAW = "chat",
}

export const enum FILE_MANAGEMENT {
  FILE = "file",
  FOLDER = "folder",
}
export const enum LAW_TYPES {
  LAW = "law",
  LAW_CASE = "law_case",
}
export const FILE_STATUS = {
  PROCESSING: "processing",
  COMPLETED: "completed",
  FAILED: "failed",
};

// File status numeric values from API
export const FILE_STATUS_NUMERIC = {
  IN_PROGRESS: 1,
  COMPLETED: 2,
  FAILED: 3,
} as const;

export const CHAT_MODE = {
  PROJECT: "project",
  INTEGRATED: "integrated",
};

export const LEGAL_CHATMODE = {
  WEB_SEARCH: 1,
  LAW_INFO_CENTER: 2,
};

export const DASHBOARD_TYPE = {
  CHAT: "chat",
  REPORT: "report",
};

export const WEB_SEARCH_MODEL = {
  CLAUDE_SONNET: 1,
  MIDM: 2,
};

export const LAW_INFO_CENTER_MODEL = {
  CLAUDE_SONNET: 1,
  CLAUDE_OPUS: 2,
};

export const modelOptions = [
  {
    label: "CLAUDE SONNET 4.5",
    type: 1,
    key: "claude",
  },
  {
    label: "MIDM",
    type: 2,
    key: "midm",
  },
];

export const modelOptionsFile = [
  {
    label: "CLAUDE SONNET 4.5",
    type: 1,
    key: "claude",
  },
  {
    label: "CLAUDE OPUS 4.5",
    type: 3,
    key: "opus",
  },
  {
    label: "MIDM",
    type: 2,
    key: "midm",
  },
];


// Model mapping based on key
export const MODEL_NAMES: Record<number, string> = {
  3: "gpt-4.1", //multidoc chatbot
  4: "claude-sonnet-4-5-20250929", //project document chatbot
  5: "gemini-2.5-pro", //drawing analysis chatbot
  6: "MIDM", //kcs
  7: "gpt-4.1-mini", //verification
  8: "gemini-2.5-pro + claude-3-7-sonnet-latest", //material camparasion
};

export const CHAT_TYPE = {
  LAW_CHATBOT: 1,
  DOCUMENT_QUERY: 2,
  MULTI_DOCUMENTS_QUERY: 3,
  PROJECT_CHATBOT: 4,
  DRAWING_ANALYSIS_CHAT: 5,
  KCS: 6,
  VERIFICATION: 7,
};

export const modelOptionsWebSearch = [
  {
    label: "CLAUDE SONNET 4.5",
    type: 1,
    key: "claude",
  },
  {
    label: "CLAUDE OPUS 4.5",
    type: 2,
    key: "opus",
  },
];

export const getChatOptions = () => [
  {
    value: "chat",
    label: t("common:projects.lawMode"),
  },
  {
    value: "search",
    label: t("common:projects.lawCaseMode"),
  },
];

export const getDocChatOptions = () => [
  {
    value: "integrated",
    label: t("common:projects.integratedMode"),
  },
  {
    value: "project",
    label: t("common:projects.projectMode"),
  },
];

export const getSearchTabs = () => [
  {
    label: t("common:translate.webSearch"), // translation key for WEB SEARCH
    type: LEGAL_CHATMODE.WEB_SEARCH,
  },
  {
    label: t("common:translate.lawInfoCentre"), // translation key for LAW INFO CENTER
    type: LEGAL_CHATMODE.LAW_INFO_CENTER,
  },
];

export enum VIEW_TYPE {
  PROJECT = "project",
  FOLDER = "folder",
  DOCUMENT = "document",
}

export enum TAB_TYPES {
  REPORT_HISTORY = 1,
  CHAT_HISTORY = 2,
}

export enum DOCUMENT_TYPE {
  DOCUMENT = "document",
  CHECKLIST = "checklist",
}

export enum FILE_EXTENION {
  PDF = "pdf",
  DOCX = "docx",
  XLSX = "xlsx",
}

export enum CHAT_ACTIONS {
  LIKE = "like",
  DISLIKE = "dislike",
  COPY = "copy",
  EDIT = "edit",
  SETTINGS = "settings",
}

export const FILE_TYPE = {
  SIMPLE_FILE: 1,
  EXTRACTION_REVIEW: 2, //PERMIT REVIEW,ITEM EXTRACTION
  EXCEL_AUTO_COMPLETE: 3, //LEGAL
  DRAWING_ANALYSIS: 4,
  FINISHING_MATERIAL_REQUEST: 5,
  //LEGAL_REVIEW: 6,
  MULTI_DOC: 6,
};

export const FINISHING_MATERIAL_SUBTYPE = {
  DRAWING_FILE: 1,
  CONTRACT_FILE: 2,
};

// Re-export the comprehensive file size formatter from utils
export { formatFileSizeSmart as formatFileSize } from "@root/utils/file-size-helper";

// Relative time formatter
export const timeAgo = (date: Date) => {
  const diff = Math.floor((Date.now() - date.getTime()) / 1000); // in sec
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} hr ago`;
  return `${Math.floor(diff / 86400)} d ago`;
};

export const DOCUMENT_STATUS = {
  PROCESSING: [0, 1, 2, 3, 4, 5, 6, 7, 10],
  COMPLETED: 8,
  ERROR: 9,
};

export const FINISHING_MATERIAL_STATUS = {
  PROCESSING: [0, 1, 2, 3, 4, 5, 6, 7, 10],
  COMPLETED: 8,
  ERROR: 9,
};

export const MODULE_TYPE = {
  FILE: "FILE",
  CHAT: "CHAT",
};

export const FILE_KIND = {
  PDF: "pdf",
  DOCX: "docx",
  XLSX: "xlsx",
  IMAGE: "image",
  OTHER: "other",
} as const;

export type FileKind = (typeof FILE_KIND)[keyof typeof FILE_KIND];

export const PAYLOAD_TYPE = {
  DEFAULT: "default",
  VERIFY: "verify",
};
